import Legend from 'ol-ext/legend/Legend';
import LegendCtrl from 'ol-ext/control/Legend';
import { Fill, Style, Icon, Text } from 'ol/style.js';
import { itineraryEntries, travels, chronological } from './source.js';
import { loadLanguageOL } from './translations.js';

var textStyle = new Text({
  font: '16px Albert Sans, sans-serif',
  fill: new Fill({
    color: 'black'
  }),
});

var titleStyle = new Text({
  font: '22px Albert Sans, sans-serif',
  fill: new Fill({
    color: 'black'
  }),
});


export var legend = new Legend({
  margin: 5,
  maxWidth: 300,
  textStyle: titleStyle,
});
export var legendCtrl = new LegendCtrl({
  legend: legend,
  collapsed: false,
  textStyle: titleStyle,
  target: $("#nav-legend").get(0),
});

export function entriesLegendItems(lang) {

  var itineraryEntriesLegend = new Legend({ layer: itineraryEntries, margin: 4, textStyle: textStyle, })

  itineraryEntriesLegend.addItem({ title: loadLanguageOL(lang, "entriesLegendTitle") })

  itineraryEntriesLegend.addItem({
    textStyle: textStyle,
    title: loadLanguageOL(lang, "entriesLegendData"),
    typeGeom: 'Point',
    style: new Style({
      image: new Icon(({
        scale: 0.14,
        src: './assets/images/entry.png',
      }))
    })
  })

  return itineraryEntriesLegend
}


export function travelsLegendItems(lang) {
  var travelsLegend = new Legend({ layer: travels, margin: 4, textStyle: textStyle, })
  travelsLegend.addItem({ title: loadLanguageOL(lang, "travelsLegendTitle") })

  var travelsLegend_en = {
    'Early years [1485–1518]': 'travel_green.png',
    'Diplomat [1518– 1532]': 'travel_blue.png',
    'Bishop [1532– 1548]': 'travel_purple.png'
  };

  var travelsLegend_pl = {
    'Młodość [1485–1518] ': 'travel_green.png',
    'Dyplomata [1518– 1532]': 'travel_blue.png',
    'Biskup [1532– 1548]': 'travel_purple.png'
  };

  if (lang == 'pl')
    var travelsLegendLang = travelsLegend_pl
  else
    var travelsLegendLang = travelsLegend_en

  for (var i in travelsLegendLang) {
    travelsLegend.addItem({
      title: i,
      typeGeom: 'Point',
      style: new Style({
        image: new Icon(({
          scale: 0.2,
          src: "./assets/images/" + travelsLegendLang[i],
        }))
      })
    });
  }
  return travelsLegend
}


export function chronologicalLegendItems(lang) {

  var chronologicalLegend = new Legend({ layer: chronological, margin: 4, textStyle: textStyle, })

  chronologicalLegend.addItem({ title: loadLanguageOL(lang, "chronologicalLegendTitle") })

  chronologicalLegend.addItem({
    textStyle: textStyle,
    title: loadLanguageOL(lang, "chronologicalLegendData"),
    typeGeom: 'Point',
    style: new Style({
      image: new Icon(({
        scale: 0.2,
        src: "./assets/images/travel_black.png",
      }))
    })
  });

  return chronologicalLegend
}


legend.addItem(entriesLegendItems('en'))
legend.addItem(chronologicalLegendItems('en'))
legend.addItem(travelsLegendItems('en'))


